module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/417.c219f34b.png";